/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Table, Form } from 'react-bootstrap';
import { useState, useEffect, useContext } from 'react';
import Select from 'react-select';
import { postRequestOptions, getRequestOptions } from "../helpers/Fetchwrapper";
import { Card } from 'react-bootstrap-v5';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { numberFormat } from '../helpers/GlobalHelper';
import { useLocation, Link } from "react-router-dom";
import { AppContext } from '../context/AppContext'

// Define a type for the sales data
interface CollectionData {
    idAccLedgers: number;
    idCompanies: number;
    ledgerName: string;
    ledgerCode: string;
    ledgerType: string;
    category: string;
    openingAmount: number;
    transactions: any[];
};

interface CollectionReportProps { }

const CollectionReportV2: React.FC<CollectionReportProps> = (props) => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const { currentUser } = useContext(AppContext);

    const [loading, setLoading] = useState(false);
    const [collectionData, setCollectionData] = useState<CollectionData[]>([]);
    const [formData, setFormData] = useState({
        idProjects: query.get('idProjects') ?? '',
        fromDate: query.get('fromDate') ?? '',
        toDate: query.get('toDate') ?? '',
        idSr: query.get('idSr') ?? '',
        noTxnAvail: true
    })
    const [noTxnAvail, setNoTxnAvail] = useState(true);

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [sr, setSr] = useState({ label: 'Select SR', value: '' });
    const [salesRepresentatives, setSalesRepresentatives] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        getProjects();
        getAllSalesRepresentative()
    }, [])

    useEffect(() => {
        
        
        if(projects.length>0){
            const projectObj = Number(query.get('idProjects')) ? projects.find((project: any) => project.value === Number(query.get('idProjects'))) : projects[0];
            setProject(projectObj);
            setFormData({
                ...formData,
                idProjects: projectObj ? projectObj.value : '',
            });

        }else{
            setProject({ label: 'Select Project', value: '' });
        }
        
        if(salesRepresentatives.length>0){
            const salesRepresentativeObj = salesRepresentatives.find((salesRepresentative: any) => salesRepresentative.value === Number(query.get('idSr')));
            if(salesRepresentativeObj){
                setSr({
                    label: salesRepresentativeObj?.label,
                    value: salesRepresentativeObj?.value
                });
            }else{
                setSr({ label: 'Select SR', value: '' });
            }
            
        }else{
            setSr({ label: 'Select SR', value: '' });
        }

        if (formData.fromDate && formData.toDate) {
            handleViewReport();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects, salesRepresentatives]);

    const getAllSalesRepresentative = () => {
    
        fetch(
            process.env.REACT_APP_API_URL + 'getAllSr',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let users = resp.map((item: any) => {
                    const capitalizedStatus = item.status.charAt(0).toUpperCase() + item.status.slice(1); // e.g., 'active' -> 'Active'
                    item.label = `${item.first_name} ${item.last_name} (${item.assigned_projects} projects, ${capitalizedStatus})`;
                    item.value = item.id;
                    return item
                })
                setSalesRepresentatives(users);

            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })


    }

    const handleSrChange = (selectedOption: any) => {
        if (!selectedOption) {
            selectedOption = { label: 'Select SR', value: '' };
        }

        setSr(selectedOption);
        setFormData({ ...formData, idSr: selectedOption.value });
    };

    useEffect(() => {
        if (currentUser?.id_roles === 1) {
          setFormData(prev => ({
            ...prev,
            idSr: currentUser.id
          }));
        }
      }, [currentUser]);

    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleProjectChange = (project: any) => {
        setProject(project);
        if (project) {
            setFormData({ ...formData, idProjects: project.value });
        } else {
            setFormData({ ...formData, idProjects: 0 });
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleViewReport = async () => {
        setLoading(true);

        // if(currentUser.idRoles === 1){
            
        // }

        try {
            const response = await fetch(process.env.REACT_APP_API_URL + 'reports/collection-v2', postRequestOptions(formData));
            const data = await response.json();
            if (data.success) {
                setCollectionData(data.data);
            } else {
                setCollectionData([]);
                data.errors.forEach((error: string) => toast.error(error, { position: 'bottom-right', autoClose: 4000 }));
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setLoading(false);
        }
    };

    const noTxnAvailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNoTxnAvail(event.target.checked);
        setFormData({ ...formData, noTxnAvail: event.target.checked });
    };

    const queryParams = new URLSearchParams(formData);

    // Filter collectionData based on search term
    const filteredCollectionData = collectionData.filter((company) => {
        if (!searchTerm.trim()) {
            return true;
        }
        const searchLower = searchTerm.toLowerCase();
        return company.ledgerName.toLowerCase().includes(searchLower) ||
               company.ledgerCode.toLowerCase().includes(searchLower);
    });

    return (
        <>
            <Card className='mb-4'>
                <Card.Body>
                    <Card.Title></Card.Title>
                    <Card.Text>
                        <div className='row'>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>Project<span className='required'></span></Form.Label>
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isClearable={true}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb3" controlId="fromDate">
                                    <Form.Label>From Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="From Date" name='fromDate' value={formData.fromDate} onChange={handleChange} />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="toDate">
                                    <Form.Label>To Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="To Date" name='toDate' value={formData.toDate} onChange={handleChange} />
                                </Form.Group>
                            </div>
                            {/* {JSON.stringify(formData, null, 2)} */}
                            {currentUser?.id_roles !== 1 &&
                                <div className='col-md-2'>
                                    <Form.Group className="mb-3" controlId="project">
                                        <Form.Label>Select SR</Form.Label>
                                        <Select
                                            value={sr}
                                            onChange={handleSrChange}
                                            options={salesRepresentatives}
                                            menuPosition="fixed"
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            isClearable={true}
                                        />
                                    </Form.Group>
                                </div>
                            }
                            <div className='col-md-1'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <button className='btn btn-sm btn-primary w-100 p-3' onClick={handleViewReport} disabled={loading}>
                                        {loading && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}
                                        <span>View Report</span>
                                    </button>
                                </div>
                            </div>
                            <div className='col-md-1'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <a className="btn btn-sm btn-primary w-100 p-3 mb-2" href={`${process.env.REACT_APP_BACKEND}collection_report_v2_download?` + queryParams.toString()}><i className='fas fa-download'></i>Download</a>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <Form.Group className="mt-6" controlId="showRate">
                                    <Form.Label></Form.Label>
                                    <Form.Check // prettier-ignore
                                        type="switch"
                                        id="custom-switch"
                                        label="No Transactions Available"
                                        className="form-switch"
                                        checked={noTxnAvail}
                                        onChange={noTxnAvailChange}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </Card.Text>
                </Card.Body>
            </Card>

            <div className='row mb-3'>
                <div className='col-md-4 ms-auto'>
                    <Form.Group controlId="searchBox">
                        <Form.Control 
                            type="text" 
                            placeholder="Search by Party Name..." 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </Form.Group>
                </div>
            </div>

            <div className='row'>
                <div className='col-12'>
                    <Table responsive bordered hover>
                        <thead>
                            <tr>
                                <th className='text-center'>SL</th>
                                <th className='text-center'>Party Name</th>
                                <th className='text-center'>Inv. Dt.</th>
                                <th className='text-center'>Inv/MR No</th>
                                <th className='text-center'>Recv. Dt.</th>
                                <th className='text-center'>Sales</th>
                                <th className='text-center'>Payment Received</th>
                                <th className='text-center'>Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredCollectionData.length > 0 ? (() => {
                                let serialNo = 0;
                                return filteredCollectionData.map((company) => {
                                   
                                    // Skip companies with no transactions if `noTxnAvail` is true
                                    if (noTxnAvail && company.transactions.length === 0) {
                                        return null; // return null instead of using continue
                                    }

                                    serialNo++; // Increment serial number for each displayed company
                                    let runningBalance = Number(company.openingAmount); // Initialize running balance with opening balance
                                    return (
                                        <React.Fragment key={company.idCompanies}>
                                           
                                            <tr>
                                                <td className='text-center' rowSpan={company.transactions.length + 1}>{serialNo}</td>
                                                <td rowSpan={company.transactions.length + 1}>
                                                    
                                                    {currentUser?.id_roles === 1 ?
                                                        <Link to={`sr-ledger-statement?idProjects=${formData?.idProjects}&idAccLedgers=${company.idAccLedgers}&fromDate=${formData?.fromDate}&toDate=${formData?.toDate}`}>
                                                            {company.ledgerName}
                                                        </Link>
                                                        : 
                                                        <Link to={`reports?type=ledgerStatement&idProjects=${formData?.idProjects}&idAccLedgers=${company.idAccLedgers}&fromDate=${formData?.fromDate}&toDate=${formData?.toDate}`}>
                                                            {company.ledgerName}
                                                        </Link>
                                                    }
                                                </td>
                                                <td className='text-center' colSpan={5}><strong>Opening Balance</strong></td>
                                                <td className='text-end'>{numberFormat(company.openingAmount)}</td>
                                            </tr>
                                        {company.transactions.map((data, index) => {
                                            // Update the running balance
                                            if (data.drcr === 'dr') {
                                                runningBalance += Number(data.dr_amount);
                                            } else if (data.drcr === 'cr') {
                                                runningBalance -= Number(data.cr_amount);
                                            }

                                            // Update totals
                                            // totalBalance += runningBalance;

                                            return (
                                                <tr key={index}>
                                                    <td className='text-center'>{data.drcr === 'dr' ? data.voucher_date : ''}</td>
                                                    <td className='text-center'>
                                                        {data.invoice_id === null && data.transaction_id === null ? data.voucher_no :
                                                            data.drcr === 'dr' ? data.invoice_id : data.transaction_id
                                                        }
                                                    </td>
                                                    <td className='text-center'>{data.drcr === 'cr' ? data.voucher_date : ''}</td>
                                                    <td className='text-end'>{data.drcr === 'dr' ? numberFormat(data.dr_amount) : ''}</td>
                                                    <td className='text-end'>{data.drcr === 'cr' ? numberFormat(data.cr_amount) : ''}</td>
                                                    <td className='text-end'>{numberFormat(runningBalance)}</td>
                                                </tr>
                                            );
                                        })}


                                    </React.Fragment>
                                    );
                                });
                            })() : (
                                <tr>
                                    <td colSpan={8} className='text-center'>No Data Found</td>
                                </tr>
                            )}
                        </tbody>
                        {filteredCollectionData.length > 0 && (() => {
                            // Calculate totals for filtered data only
                            let filteredTotalSales = 0;
                            let filteredTotalPayments = 0;
                            let filteredTotalOpening = 0;
                            
                            filteredCollectionData.forEach((company) => {
                                if (noTxnAvail && company.transactions.length === 0) {
                                    return;
                                }
                                filteredTotalOpening += Number(company.openingAmount);
                                company.transactions.forEach((data) => {
                                    if (data.drcr === 'dr') {
                                        filteredTotalSales += Number(data.dr_amount);
                                    } else if (data.drcr === 'cr') {
                                        filteredTotalPayments += Number(data.cr_amount);
                                    }
                                });
                            });

                            return (
                                <tfoot>
                                    <tr>
                                        <td colSpan={5} className='text-end'><strong>Total</strong></td>
                                        <td className='text-end'><strong>{numberFormat(filteredTotalSales)}</strong></td>
                                        <td className='text-end'><strong>{numberFormat(filteredTotalPayments)}</strong></td>
                                        <td className='text-end'><strong>{numberFormat(filteredTotalOpening+filteredTotalSales-filteredTotalPayments)}</strong></td>
                                    </tr>
                                </tfoot>
                            );
                        })()}
                    </Table>
                </div>
            </div>
        </>
    );
};

export default CollectionReportV2;
